import {SmartpriseApiClient} from "../Api/Client";

export class DataLayer {
    public static meta: JQuery;
    public static templates: Record<string, string> = {};

    protected RetireveEnteEndPoint: string = 'https://prova.babyloweb.eu/recuperi_api/findente.php';
    protected email_regex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    protected readonly entiTrentino: string[] = [
        'fassa',
        'fiemme',
        'primiero',
        'avisio',
        'rotalianakonigsberg',
        'bassavalle',
        'altavalle',
        'valdisole',
        'altogardaeledro',
        'tione',
        'valrendena',
        'valledelchiese',
        'roveretoevallidelleno',
        'alaavio',
        'mori2',
        'altavallagarina',
        'trento2',
        'valledeilaghi',
        'bassavalsuganaetesino',
        'altavalsugana',
        'mezzana',
        'cembralisignano',
        'cavedine',
        'altavaldifiemme',
        'paganella',
        'civezzano',
        'commezzadura',
        'bassavaldisole',
        'dimarofolgarida',
        'ossanapellizzano',
        'peio',
        'rabbi',
        'vermiglio',
        'andalo'
    ];

    protected client: SmartpriseApiClient = SmartpriseApiClient.getInstance();
    protected url_params: URLSearchParams;


    public GetPage(): string {
        // @ts-ignore
        return globalThis.page ?? this.url_params.get("page");
    }

    public ToMySqlFormat(date: Date): string {
        return date.toISOString().slice(0, 19).replace('T', ' ');
    }

    public static safe_get_template(name: string) {
        const rt = this.templates[name];
        if (rt === undefined) {
            alert(`Template ${name} not found`)
            throw new Error(`Template ${name} not found`);
        }

        return rt;
    }

}